// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  border: none;
  cursor: pointer;
  padding: 14px 7px 13px 6px;
  background: transparent url('${(props) => getIconPath('modal-close', props)}') no-repeat 0 0;
  background-size: 100% 100%;
  width: 15px;
  height: 15px;
  ${(props) => (props.isCouponButtonVisible ? `position: absolute;` : ``)}
  @media ${(props) => props.theme.mediaQuery.medium} {
    position: absolute;
  }
  &.alignRight {
    ${(props) =>
      props.isCouponButtonVisible
        ? `
      right: 32px;
      top: 50%;
      ${
        props.isMultipleSlide
          ? `transform: translate(-50%, 50%);`
          : `transform: translate(-50%, -50%)`
      };
    `
        : ``}
    @media ${(props) => props.theme.mediaQuery.medium} {
      right: 32px;
      top: 50%;
      ${(props) =>
        props.isMultipleSlide
          ? `transform: translate(-50%, 50%);`
          : `transform: translate(-50%, -50%)`};
    }
    background-color: ${(props) => props.theme.colorPalette.gray[300]};
    border-radius: 50%;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
  }
`;
